import { alpha } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { SBWIDTH } from '../AssessmentScore/styles';
import { isDark } from 'global/styles';

const IMAGE = 100;

const useStyles = makeStyles((theme) => ({
  cpScoreHeaderChild: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    '@media print': {
      display: 'block',
    },
    width: 48,
    minWidth: 48,
    margin: 0,
  },
  loadContainer: {
    height: 4,
    width: '100%',
  },
  headerChildName: {
    margin: 0,
    marginRight: theme.spacing(1),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    overflowX: 'auto',
  },
  checklist: {
    pageBreakInside: 'avoid',
  },
  checklistFirst: {
    pageBreakBefore: 'avoid',
  },
  checklistHeader: {
    top: 48,
    zIndex: 2,
    paddingLeft: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    clear: 'both',
  },
  checklistHeaderBorder: {
    borderBottom: '1px solid lightgrey',
  },
  checklistHeaderCourse: {
    zIndex: 2,
    paddingLeft: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    borderBottom: '1px solid lightgrey',
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
  checklistContainerPrint: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    '& .IMAGE': {
      float: 'right',
      width: '40%',
      paddingLeft: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  },
  headerBtn: {
    color: 'red',
  },
  headerCriteria: {
    lineHeight: 0,
    position: 'absolute',
    fontSize: '10px',
    bottom: theme.spacing(1),
    color: theme.colors.grey,
    fontWeight: 'normal',
  },
  checklistImage: {
    cursor: 'pointer',
    '& :hover': {
      opacity: 0.8,
    },

    '& .IMAGE': {
      [theme.breakpoints.up('md')]: {
        position: 'sticky',
        top: 110,
      },
    },
  },
  row: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
  rowIndent: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    marginLeft: theme.spacing(3),
  },
  rowTop: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  moreIcon: {
    marginLeft: 'auto',
  },
  link: {
    marginLeft: theme.spacing(2.5),
    [theme.breakpoints.down['md']]: {
      marginLeft: theme.spacing(2),
    },
    color: theme.palette.secondary.main,
    textDecoration: 'none',
    fontStyle: 'italic',
    fontWeight: 'bold',
    fontSize: 14,
    padding: theme.spacing(1),
  },
  images: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  imagesprint: {
    '& .caption': {
      color: theme.palette.text.primary,
    },
  },
  imageWrap: {
    height: IMAGE,
    width: IMAGE,
  },
  image: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: IMAGE,
    '&:hover': {
      cursor: 'pointer',
      opacity: '0.7',
    },
  },
  topic: {
    padding: '6px 6px 6px 16px',
    pageBreakInside: 'avoid !important',
  },
  topicEdit: {
    padding: '6px 6px 6px 16px',
    marginBottom: theme.spacing(2),
  },
  topicFlex: {
    display: 'flex',
  },
  cpscoreHidden: {
    marginLeft: 76,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 28,
    },
  },
  criteria: {
    color: isDark(theme) ? theme.palette.text.primary : 'red',
    fontSize: 12,
    marginBottom: theme.spacing(1),
  },
  progWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: 150,
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  grow: {
    flexGrow: 1,
  },
  edit: {
    marginLeft: theme.spacing(1),
    [theme.breakpoints.down('xl')]: {
      display: 'none',
    },
  },
  sentinel: {
    left: 0,
    right: 0,
    top: -60,
    height: 12,
    position: 'absolute',
    visibility: 'hidden',
  },
  spacerTop: {
    height: theme.spacing(2),
  },
  spacerBottom: {
    height: theme.spacing(4),
  },

  imgCaption: {
    color: theme.palette.text.secondary,
    fontSize: 10,
  },
  buttonRoot: {
    [theme.breakpoints.down('md')]: {
      minWidth: 48,
    },
  },

  roomBtnContainer: {
    margin: `${theme.spacing(1)} 0px`,

    '& .roomBtn': {
      marginLeft: 0,
    },
  },

  rComment: {
    width: '100%',
    backgroundColor: alpha(theme.colors.red, 0.2),
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1),
    boxSizing: 'border-box',
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(4),
    maxWidth: `calc(100% - ${theme.spacing(4)})`,
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
      maxWidth: '100%',
    },

    '& .column': {
      maxWidth: `calc(100% - ${theme.spacing(5)})`,
      alignItems: 'flex-start',
      marginLeft: theme.spacing(4),
    },

    '& .textContainer': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      width: '100%',
    },

    '& .MuiTextField-root': {
      width: '100%',
    },
    '& .MuiInputBase-root': {
      backgroundColor: theme.palette.background.paper,
    },
    '& .textRow': {
      justifyContent: 'space-between',
      position: 'relative',

      '& .indicator': {
        position: 'absolute',
        left: -20,
        width: 16,
        height: 16,
        borderRadius: 16,
        backgroundColor: theme.colors.black,
      },
    },
    '& .btnRow': {
      justifyContent: 'flex-end',

      '& button': {
        marginLeft: theme.spacing(1),
      },
    },
  },

  rCommentCheckpointEdit: {
    marginLeft: 0,
    maxWidth: '100%',
  },

  fixedBottomNav: {
    position: 'relative',
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',

    '& button': {
      marginRight: theme.spacing(1),
    },
  },
}));

export default useStyles;
